import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useParams, useHistory } from "react-router-dom";
import {
	xhrPatientGetPatientById,
	xhrPatientGetPatientByIdentification,
	xhrPatientGetPatientBySearch,
} from "../../utilities/xhr-patient";
import { formattedDate, formattedAge } from "../../utilities/dateFormatter";
import PatientDataTab from "./PatientDataTab";
import PatientHistoryTab from "./PatientHistoryTab";
import toastUtil from "../../utilities/toast-util";
import translator from "../../utilities/translator.js";

export default function PatientEditor() {
	const params = useParams();
	const history = useHistory();
	const dispatch = useDispatch();

	const token = useSelector((state) => state.session.token);
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);
	const identParam = new URLSearchParams(window.location.search).get("ident");
	const tidParam = new URLSearchParams(window.location.search).get("tid");
	const pnhsParam =
		new URLSearchParams(window.location.search).get("nhsId") ??
		new URLSearchParams(window.location.search).get("nhsid");
	const [currTab, setCurrTab] = React.useState(1);

	const [selectedPatient, setSelectedPatient] = React.useState(null);
	React.useEffect(() => {
		let mountedRef = true;
		if (params.id) {
			const effectPromise = async () => {
				var data = await xhrPatientGetPatientById(token, params.id);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				if (data?.result?.data?.address) {
					data.result.data.address = data?.result?.data?.address?.replaceAll(
						"^",
						" "
					);
				}
				setSelectedPatient(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [params.id, token]);

	React.useEffect(() => {
		let mountedRef = true;
		if (tidParam?.length > 0 && identParam?.length > 0) {
			const effectPromise = async () => {
				var data = await xhrPatientGetPatientByIdentification(
					token,
					tidParam,
					identParam
				);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				if (data?.result?.data?.address) {
					data.result.data.address = data?.result?.data?.address?.replaceAll(
						"^",
						" "
					);
				}
				setSelectedPatient(data?.result?.data);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [identParam, tidParam, token]);

	React.useEffect(() => {
		let mountedRef = true;
		if (tidParam?.length > 0 && pnhsParam?.length > 0) {
			const effectPromise = async () => {
				var data = await xhrPatientGetPatientBySearch(token, {
					tenantIds: [tidParam],
					nhsId: pnhsParam,
				});
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;

				let pat = data?.result?.data[0];
				if (pat?.address) {
					data.result.data.address = data?.result?.data?.address?.replaceAll(
						"^",
						" "
					);
				}
				setSelectedPatient(pat);
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [pnhsParam, tidParam, token]);

	console.log({ selectedPatient });

	const [activeTab, setActiveTab] = React.useState(1);

	return (
		<div
			className="patientdata-tabs bg-white "
			style={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				padding: "15px",
			}}
		>
			<div>
				<ul className="nav nav-tabs" style={{ float: "left" }}>
					<li className="nav-item">
						<div style={{ position: "relative" }}>
							<a
								style={{ paddingRight: "28px" }}
								className={"nav-link " + (activeTab === 1 ? "active" : "n")}
								href="#patHistArea"
								onClick={(e) => setActiveTab(1)}
							>
								{translator(currentLanguage, "patient_history")}
							</a>
						</div>
					</li>
				</ul>

				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							gap: "20px",
							border: "1px solid #ddd",
							borderRadius: "8px",
							padding: "4px 16px",
						}}
					>
						<div>
							<strong>{translator(currentLanguage, "pat_id")}:</strong>{" "}
							{selectedPatient?.id || "NA"}
						</div>
						{"|"}
						<div>
							<strong>{translator(currentLanguage, "pat_ident")}:</strong>{" "}
							{selectedPatient?.identification || "NA"}
						</div>
						{"|"}
						<div style={{ fontWeight: 600 }}>
							<strong>{translator(currentLanguage, "pat_name")}:</strong>{" "}
							{selectedPatient
								? [
										selectedPatient.firstName,
										selectedPatient.middleName,
										selectedPatient.lastName,
								  ].join(" ")
								: ""}
						</div>
						{"|"}
						<div>
							<strong>{translator(currentLanguage, "pat_dob")}:</strong>{" "}
							{selectedPatient?.dob
								? `${formattedDate(selectedPatient.dob)} - ${formattedAge(
										selectedPatient.dob
								  )}`
								: "NA"}
						</div>
					</div>
				</div>
			</div>
			{/* Tab panes */}
			<div className="tab-content" style={{ overflow: "auto" }}>
				<div style={{ height: "100%" }}>
					<PatientHistoryTab patient={selectedPatient} />
				</div>
			</div>
		</div>
	);
}
